import React from 'react'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import {
  Box,
  CircularProgress,
  Typography
} from '@mui/material'

interface LoadingStateProps {
  message?: string
  size?: number
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  message = 'Cargando datos...',
  size = 40
}) => {
  const styles = useStyles()

  return (
    <Box className={styles.container}>
      <Box className={styles.content}>
        <CircularProgress size={size} className={styles.spinner} />
        <Typography variant="body1" className={styles.message}>
          {message}
        </Typography>
      </Box>
    </Box>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '200px',
    padding: theme.spacing(4)
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center'
  },
  spinner: {
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main
  },
  message: {
    color: theme.palette.grey[600]
  }
}))